import {computed} from "vue";
import store from "../store";

export function useRole() {
  const isBrand = computed(() => store?.getters['auth/user']?.roles.find(role => role.title === 'Brand') !== undefined)
  const isCreator = computed(() => store?.getters['auth/user']?.roles.find(role => role.title === 'Creator') !== undefined)

  return {
    isBrand,
    isCreator,
  }
}
